import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Settings from "./Settings";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

const drawerWidth = 240;

const Dashboard = () => {
  const [isOpen, setIsOpen] = useState(false); // Iniciar Drawer cerrado para móviles
  const [isMobile, setIsMobile] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    // Detectar el tamaño de la ventana y establecer si es móvil o escritorio
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true); // Establece como móvil si el ancho es menor que 768px
        setIsOpen(false); // Cierra el drawer en móviles por defecto
      } else {
        setIsMobile(false); // Establece como escritorio si el ancho es mayor o igual a 768px
        setIsOpen(true); // Abre el drawer en escritorio
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Llamar a la función para ajustar el estado inicial

    // Limpiar el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Asegura que no haya desplazamiento horizontal
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Nav isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isOpen ? `${drawerWidth}px` : 0, // Desplazar contenido si el drawer está abierto
          transition: "margin-left 0.3s ease-in-out",
          width: isOpen ? `calc(100% - ${drawerWidth}px)` : "100%", // Ajusta el ancho dependiendo de si el drawer está abierto o no
          overflowX: "hidden",
        }}
      >
        <AppBar
          className="appbar"
          position="static"
          sx={{
            backgroundColor: "#ededed",
            color: "#6e6e6e",
            marginBottom: "35px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <p>03/03/2025 Alta usuarios</p>
        <p>12/12/2025 modificación formulario / reply-to</p>
        <p>12/12/2025 formulario bajas </p>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
};

export default Dashboard;
